import script from "./HeadingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadingCard.vue?vue&type=script&setup=true&lang=js"

import "./HeadingCard.vue?vue&type=style&index=0&id=fc129162&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc129162"]])

export default __exports__